<template>
    <div class="alert-answer">
        <div class="alert-title" :class="typeExtract == 'second-chance' ? 'title-four' : ''">
            <!-- group hit -->
            <div class="title-container">
                <img :src="title.image" alt="" class="success-icon all-answer">
                <span class="all-answer-text" 
                      v-if="typeExtract != 'timeout' && typeExtract != 'moneyout'">
                        {{typeExtract != 'group-hit' ? title.title : nameCorrect }}
                </span>
                <span class="subtitle" v-if="typeExtract == 'group-hit'">{{$t("components.Alerts.AlertAnswer.subtitle")}}</span>
            </div>
            <!-- self-hit -->
            <!-- <div class="title-container" v-if="typeExtract == 'self-hit'">
                <img src="../../assets/clock.png" alt="" class="success-icon all-answer">
                <span class="all-answer-text">Resposta Correta</span>
            </div> -->
            <!-- second-chance -->
            <!-- <div class="title-container container-second" v-if="typeExtract == 'second-chance'">
                <div class="image-second">
                    <img src="../../assets/success-icon.png" alt="" class="success-icon all-answer">
                </div>
                <div class="text-second">
                    <span class="subtitle">Você inseriu</span>
                    <span class="all-answer-text">2 respostas corretas!</span>
                </div>
            </div>  -->
        </div>
        <div class="steps-alert" :class="typeExtract == 'second-chance' ? 'steps-four' : ''">
            <div class="step-alert" :class="typeExtract == 'second-chance' ? 'step-four' : ''">
                <span class="title-step">{{$t("components.Alerts.AlertAnswer.titleStep[0]")}}</span>
                <div class="money-step">
                    <span class="money">$ {{startMoney}}</span>
                </div>
            </div>
            <div class="step-alert" :class="typeExtract == 'second-chance' ? 'step-four' : ''">
                <div class="title-step">
                    <span class="title-step-text">{{$t("components.Alerts.AlertAnswer.titleStep[1]")}} ({{attempt.count}})</span>
                </div>
                <div class="money-step">
                    <span class="money red">
                        {{ attempt.moneyDecreased == 0 ? '' : '-' }} $ 
                        {{ attempt.moneyDecreased }}
                    </span>
                </div>
            </div>
            <div class="step-alert" :class="typeExtract == 'second-chance' ? 'step-four' : ''">
                <div class="title-step">
                    <span class="title-step-text">
                        {{ typeExtract == 'second-chance' ? $t("components.Alerts.AlertAnswer.titleStep[3]") : $t("components.Alerts.AlertAnswer.titleStep[4]")}}
                    </span>
                </div>
                <div class="money-step">
                    <span class="money red" v-if="typeExtract == 'second-chance'">$ 
                        {{ resolutionEquation }}
                    </span>
                    <span class="money" v-else>$
                        {{ correctAnswer }}
                    </span>
                </div>
            </div>
            <div class="step-alert" 
                 v-if="typeExtract == 'second-chance'"
                 :class="typeExtract == 'second-chance' ? 'step-four' : ''">
                <div class="title-step">
                    <span class="title-step-text">
                        <span class="more-chance">{{$t("components.Alerts.AlertAnswer.titleStep[5]")}}</span>
                        {{$t("components.Alerts.AlertAnswer.titleStep[6]")}}
                    </span>
                </div>
                <div class="money-step">
                    <span class="money">$ 
                        {{ correctAnswer }}
                    </span>
                </div>
            </div>
        </div>
        <div class="total-answer"
             :class="typeExtract == 'second-chance' ? 'total-four' : ''">
            <div class="total">
                <span class="total-text">{{$t("components.Alerts.AlertAnswer.titleStep[7]")}}</span>
            </div>
            <div class="total-money">
                <img :src="totalImage" alt="" class="total-money-img">
                <span class="total-money-text">{{ total }}</span>
            </div>
        </div>
        <div class="button-next" @click="redirect()">
            <button-button :disabled="false" textButton="$t('components.Alerts.AlertAnswer.button')"></button-button>
        </div>
    </div>
</template>
<script>
import HeaderDefault from '../Sections/HeaderDefault.vue'
import ButtonButton from '../Buttons/ButtonBottom.vue'
import firebase from '../../firebase/firebase.js'
export default {
    components : {
        HeaderDefault,
        ButtonButton
    },
    props:{
        dataExtract : {
            type : Object
        }
    },
    data(){
        return{
            startMoney : '',
            attempt : {
                count : 0,
                moneyDecreased : 0
            },
            attemptCount : '2',
            correctAnswer : '',
            resolutionEquation : 0,
            total : '',
            nameCorrect : '',
            typeExtract : ''
        }
    },
    async created(){
        let {typeExtract} = await this.$store.getters.getSimple(['typeExtract'])
        this.typeExtract = typeExtract
        if(typeExtract){
            let extract = await this.constructDataExtract(typeExtract)
            await this.constructExtract(extract.startMoney, extract.attemptCount, extract.selfCorrect, typeExtract)
            return
        }
    },
    async destroyed(){
        await firebase.destroyedApp()
    },
    methods: {
        async constructDataExtract(typeExtract){
            await firebase.destroyedApp()
            const db = firebase.constructDB()
            const { teamGameId, selfPlayer, group } = this.$store.getters.getSimple(['teamGameId', 'selfPlayer', 'group'])
            const teamGame = await db.collection('teamGames').doc(teamGameId).get()
            let attemps = teamGame.data().attempts
            if(typeExtract == 'group-hit'){
                this.playerCorrect(attemps, group)
            }

            let selfAttempt = attemps.filter(attempt => {
                return attempt.userId == selfPlayer.id
            })

            let finalAttempts = selfAttempt.filter(attempt => {
                return attempt.enigmaOrder == 'equation'
            })

            let selfCorrect = finalAttempts.some(attempt => {
                return attempt.correct
            })

            return { attemptCount : finalAttempts.length, selfCorrect, startMoney : 3000  }
        },
        constructExtract(startMoney, attemptCount, selfCorrect, typeExtract){
            this.startMoney = startMoney
            this.attempt.count = attemptCount
            this.attempt.moneyDecreased = 1000 * attemptCount
            this.correctAnswer = selfCorrect ? 15000 : 0
            if(typeExtract == 'group-hit'){
                this.correctAnswer = 8000
            }
            this.total = ( this.startMoney - this.attempt.moneyDecreased + this.correctAnswer )
        },
        redirect(){
            this.$router.push('/final-alert')
        },
        playerCorrect(attempts, group){
            let player = attempts.filter(attempt => {
                return attempt.enigmaOrder == 'equation' && attempt.correct == true
            })
            if(!player[0]){
                return
            }
            let playerId = player[0].userId
            let groupPlayer = group.filter(member => {
                return member.id == playerId
            })
            this.nameCorrect = groupPlayer[0].name
        }
    },
    computed:{
        title(){
            let {typeExtract} = this.$store.getters.getSimple(['typeExtract'])
            switch(typeExtract){
                case 'timeout':
                    return {
                        title : this.$t("components.Alerts.AlertAnswer.typeExtract[0]"),
                        image : require(`../../assets/${typeExtract}.png`)
                    }
                case 'moneyout' :
                    return {
                        title : this.$t("components.Alerts.AlertAnswer.typeExtract[1]"),
                        image : require(`../../assets/${typeExtract}.png`)
                    }
                case 'self-hit' :
                    return {
                        title : this.$t("components.Alerts.AlertAnswer.typeExtract[2]"),
                        image : require(`../../assets/success-icon.png`)
                    }
                case 'group-hit' :
                    return {
                        image : require(`../../assets/success-icon.png`)
                    }
            }
        },
        totalImage(){
            return this.total > 0 ? require('../../assets/money-success.png') : require('../../assets/money-error.png')
        }
    }
}
</script>
<style lang="scss" scoped>
    .alert-answer{

        width: 100%;
        height: calc(100vh - 65px);
        display: flex;
        flex-direction: column;

        .alert-title{

            background-color: #252a2d;
            height: 40%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .title-container{

                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;

                .success-icon{

                    height: 120px;
                    margin-bottom: 2%;
                }

                .all-answer-text{

                    color: #6defbd;
                    font-weight: bold;
                    font-size: 15px;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    margin: 5px;
                }

                .subtitle{
                    
                    color: white;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                    font-size: 11px;
                }
            }

            .container-second{

                display: flex;
                flex-direction: row;
                width: 100%;

                .image-second{
                    height: 50%;

                    img{
                        height: 100%;
                    }
                }

                .text-second{
                    display: flex;
                    flex-direction: column;
                    margin-left: 15px;
                }
            }
        }

        .title-four{
            height: 20%;
        }

        .steps-alert{

            height: 30%;

            .step-alert{

                display: flex;
                width: 100%;
                height: 33.4%;
                justify-content: space-around;
                align-items: center;

                &:nth-child(even) {
                    background: #353d41;
                }
                &:nth-child(odd) {
                    background: #3b4449;
                }

                .title-step{

                    color: white;
                    font-size: 12px;
                    width: 50%;
                    height: 50%;
                    display: flex;
                    align-items: center;
                    letter-spacing: 1px;

                    .title-step-text{
                        display: flex;
                        flex-direction: column;
                    }

                    .more-chance{
                        font-size: 8px;
                        text-transform: uppercase;
                        font-weight: bold;
                        letter-spacing: 1px;
                    }
                }

                .money-step{

                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    width: 35%;

                    .img-money-step{

                        height: 40px;
                        margin-right: 10%;
                    }

                    .money{

                        color: white;
                        font-weight: bold;
                        letter-spacing: 1px;
                    }

                    .red{
                        color: #ff64a3;
                    }
                }
            }

            .step-four{
                height: 25%;
            }
        }

        .steps-four{
            height: 45%;
        }

        .total-answer{

            background-color: #292f33;
            height: 20%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;

            .total{

                color: white;
                font-weight: bold;
                font-size: 17px;
                width: 35%;
                text-transform: uppercase;

                .total-text{

                    letter-spacing: 2px;
                    margin-left: 10%;
                }
            }

            .total-money{
                width: 50%;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .total-money-img{

                    height: 35px;
                    margin-right: 10px;
                }

                .total-money-text{

                    font-size: 22px;
                    font-weight: bold;
                    color: white;
                    letter-spacing: 2px;
                }
            }
        }

        .total-four{
            height: 15%;
        }

        .button-next{

            width: 100%;
            height: 10%;
        }
    }

    @media only screen and (min-width : 750px) {
        .alert-answer{

            height: calc(100% - 65px);

            .alert-title{
                height: 35%;
            }
        }
    }
</style>
